<template src="./BottomNavigation.html"/>
<style lang="scss" scoped src="./BottomNavigation.scss"/>
<script>
import {SfBottomNavigation, SfLink, SfIcon, SfCircleIcon, SfBadge} from '@storefront-ui/vue';
import {icons} from "@/utils/icons";


export default {
  components: {
    SfBottomNavigation,
    SfIcon,
    SfLink,
    SfCircleIcon,
    SfBadge
  },

  data() {
    return {
      icons: icons
    }
  },
  computed: {
    user: {
      get() {
        return this.$store.getters.getProfile
      }
    },
    isAuthenticated: {
      get() {
        return this.$store.getters.isAuthenticated
      }
    },
    cart: {
      get() {
        return this.$store.getters.getCart
      }
    }
  },
  methods: {
    // mutation de isModalLogin
    handleAccountClick() {
      if (this.isAuthenticated) {

        if (this.$route.name !== 'My-account') {
          return this.$router.push(this.$localizePath('/mon-compte/profil')).catch();
        }
      } else {
        this.$store.dispatch('toggleLoginModal', {open: true})
      }
    },
    toggleCartSidebar() {
      this.$store.dispatch('toggleCartSidebar')

    },
    toggleSearch() {
      // this.$store.dispatch('toggleSearch')
      this.$router.replace({path: '/recherche', query: {}}).catch(() => {
        return null
      });
    },
    toggleMenuModal() {
      this.$store.dispatch('toggleMenuModal')

    },
    goToHome() {
      if (this.$route.name !== 'Home') {
        this.$router.push(this.$localizePath("/"));
      }
    }
  }
};
</script>

